module.exports = __webpack_public_path__ + "img/icon-offline-mew.4f0c3f2d.svg";